import React from 'react';
import { createIcon } from './create-icon';
import './hamburger-menu.scss';

export const IconHamburgerMenu = createIcon(<div className="hamburger-menu" />);
